import styled from 'styled-components';

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 0;
`;

export const TimelineItem = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  min-height: 48px;

  &:last-child .timeline-line {
    display: none;
  }
`;

export const TimelineIndicator = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 24px;
  flex-shrink: 0;
  margin-right: 12px;
  position: relative;
`;

export const TimelineDot = styled.div<{ color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  flex-shrink: 0;
  margin-top: 4px;
  z-index: 1;
`;

export const TimelineLine = styled.div`
  position: absolute;
  top: 16px;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  background-color: #e1e1e1;
`;

export const TimelineContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-bottom: 24px;
`;

export const StepName = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #171717;
`;

export const StepStatus = styled.span<{ color: string }>`
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => props.color};
  margin-left: 8px;
`;

export const StepMessage = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #616161;
  margin-top: 4px;
  word-break: break-word;
`;

export const DetailField = styled.div`
  margin-bottom: 12px;
`;

export const DetailLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #616161;
  margin-bottom: 2px;
`;

export const DetailValue = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #171717;
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 24px;
  margin-bottom: 24px;
`;

export const SectionHeading = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  margin-top: 8px;
  color: #171717;
`;

export const ErrorMessageField = styled.div`
  background-color: #fde7e9;
  border-left: 3px solid #d13438;
  padding: 8px 12px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #a4262c;
  word-break: break-word;
`;
